import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import useTrls from 'hooks/translation/useTrls';

import AutoInvoice from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer/AutoInvoice';
import PayerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer/PayerLink';

const Payer = ({ payerId, auto }) => {
    const trl = useTrls();

    return (
        <Fragment>
            <p>
                <AutoInvoice auto={auto} />
            </p>
            {payerId > 0 && (
                <p>
                    {trl('admin.Invoices.InvoicesTable.Invoice.payer')}
                    {NON_BREAKING_SPACE}-{NON_BREAKING_SPACE}
                    <PayerLink payerId={payerId} />
                </p>
            )}
        </Fragment>
    );
};

Payer.propTypes = {
    payerId: PropTypes.number,
    auto: PropTypes.bool,
};

export default Payer;
